import get from 'lodash/get';

import * as ActionTypes from '../../actions/types/ChecklistActionTypes';

import * as checklistHelpers from '../../components/manage/ChecklistV2/helpers';

const initialState = {
  byId: {},
  groups: [],
  selectedId: null,
  filteredTasksGroups: [],
};

const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CHECKLIST: {
      return state;
    }
    case ActionTypes.RECEIVE_CHECKLIST: {
      const taskGroups = action.payload.checklist.checklist_task_groups;
      const byId = {};
      const groups = [];

      taskGroups.forEach((taskGroup) => {
        const { tasks } = taskGroup;

        groups.push({
          label: taskGroup.label,
          taskIds: tasks.map(task => task.id)
        });

        tasks.forEach((task) => {
          byId[task.id] = {
            ...task,
            group: taskGroup.label,
          };
        });
      });

      return Object.assign(
        {},
        state,
        { byId, groups }
      );
    }
    case ActionTypes.RECEIVE_CHECKLIST_V2: {
      let filteredTasksGroups = action.payload.checklist.checklist_task_groups;
      const byId = {};
      const groups = [];
      filteredTasksGroups = filteredTasksGroups.filter(taskGroup => taskGroup.tasks.length > 0);

      filteredTasksGroups.forEach((taskGroup) => {
        const { tasks } = taskGroup;

        groups.push({
          label: taskGroup.label,
          taskIds: tasks.map(task => task.id)
        });

        tasks.forEach((task) => {
          byId[task.id] = {
            ...task,
            group: taskGroup.label,
          };
        });
      });

      return Object.assign(
        {},
        state,
        { byId, filteredTasksGroups: groups }
      );
    }
    case ActionTypes.RESET_CHECKLIST: {
      return initialState;
    }
    case ActionTypes.ADD_TASK: {
      // Todo: instead of refetching, insert new task into state
      return state;
    }
    case ActionTypes.UPDATE_TASK: {
      // Todo: instead of refetching, insert updated task into state
      return state;
    }
    case ActionTypes.REMOVE_TASK: {
      // Todo: instead of refetching, delete task from state
      return state;
    }
    case ActionTypes.RECEIVE_TASK: {
      // TODO: This endpoint removes checklist_template_name for some reason; Endpoint should return checklist_template_name for individual tasks
      const persistTaskTemplateName = get(state, ['byId', action.payload.task.id, 'checklist_template_name']);
      const byId = { ...state.byId };

      const newTask = action.payload.task;

      byId[newTask.id] = {
        ...newTask,
        checklist_template_name: persistTaskTemplateName,
        group: checklistHelpers.getTaskGroup(newTask.due_at),
      };

      return Object.assign({},
        state,
        { byId });
    }
    case ActionTypes.SELECT_TASK: {
      return Object.assign({},
        state,
        { selectedId: action.payload.id });
    }
    case ActionTypes.UNSELECT_TASK: {
      return Object.assign({},
        state,
        { selectedId: null });
    }
    default: return state;
  }
};

export default tasksReducer;



// WEBPACK FOOTER //
// ./src/reducers/checklist/tasks.js